import React from 'react'

export default function SignOutIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5331 14.8083C16.3747 14.8083 16.2164 14.75 16.0914 14.625C15.8497 14.3833 15.8497 13.9833 16.0914 13.7417L17.7831 12.05L16.0914 10.3583C15.8497 10.1167 15.8497 9.71668 16.0914 9.47501C16.3331 9.23335 16.7331 9.23335 16.9747 9.47501L19.1081 11.6083C19.3497 11.85 19.3497 12.25 19.1081 12.4917L16.9747 14.625C16.8497 14.75 16.6914 14.8083 16.5331 14.8083Z"
        fill="currentColor"
      />
      <path
        d="M18.6078 12.675H10.1328C9.79115 12.675 9.50781 12.3917 9.50781 12.05C9.50781 11.7083 9.79115 11.425 10.1328 11.425H18.6078C18.9495 11.425 19.2328 11.7083 19.2328 12.05C19.2328 12.3917 18.9495 12.675 18.6078 12.675Z"
        fill="currentColor"
      />
      <path
        d="M11.7995 19.2916C7.50781 19.2916 4.50781 16.2916 4.50781 12C4.50781 7.70831 7.50781 4.70831 11.7995 4.70831C12.1411 4.70831 12.4245 4.99165 12.4245 5.33331C12.4245 5.67498 12.1411 5.95831 11.7995 5.95831C8.24115 5.95831 5.75781 8.44165 5.75781 12C5.75781 15.5583 8.24115 18.0416 11.7995 18.0416C12.1411 18.0416 12.4245 18.325 12.4245 18.6666C12.4245 19.0083 12.1411 19.2916 11.7995 19.2916Z"
        fill="currentColor"
      />
    </svg>
  )
}
